import React, {createContext, useContext,  useRef} from 'react';

const CodeSearchContext = createContext();

export const useCodeSearchContext = () => useContext(CodeSearchContext);

export const CodeSearchProvider = ({ children }) => {
    const handleCodeSearchRef = useRef();

    return (
        <CodeSearchContext.Provider value={{ handleCodeSearchRef }}>
            {children}
        </CodeSearchContext.Provider>
    );
};